import { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import SiteLayout from './components/SiteLayout';
import AnalyticsTracker from './components/AnalyticsTracker';
import HomePage from './routes/HomePage';
import ProductsPage from './routes/ProductsPage';
import ProductDetailPage from './routes/ProductDetailPage';
import AboutPage from './routes/AboutPage';
import KidSafePage from './routes/KidSafePage';
import DistributorsPage from './routes/DistributorsPage';
import ContactPage from './routes/ContactPage';
import BlogListPage from './routes/BlogListPage';
import BlogPostPage from './routes/BlogPostPage';
import EnterprisePage from './routes/EnterprisePage';
import MolecularPurityPage from './routes/MolecularPurityPage';
import FlagshipPage from './routes/FlagshipPage';
import PrecisionLabPage from './routes/PrecisionLabPage';
import AssurancePage from './routes/AssurancePage';
import NotFoundPage from './routes/NotFoundPage';

const AdminApp = lazy(() => import('./admin/AdminApp'));

export default function App() {
  return (
    <>
      <AnalyticsTracker />
      <Routes>
        <Route element={<SiteLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/products/:sku" element={<ProductDetailPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/kid-safe" element={<KidSafePage />} />
          <Route path="/enterprise" element={<EnterprisePage />} />
          <Route path="/molecular-purity" element={<MolecularPurityPage />} />
          <Route path="/flagship" element={<FlagshipPage />} />
          <Route path="/precision-lab" element={<PrecisionLabPage />} />
          <Route path="/assurance" element={<AssurancePage />} />
          <Route path="/distributors" element={<DistributorsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
        <Route
          path="/admin/*"
          element={
            <Suspense fallback={<div className="p-10 text-center text-slate-500">Loading admin…</div>}>
              <AdminApp />
            </Suspense>
          }
        />
      </Routes>
    </>
  );
}
